import { StrapiImage } from "./common";
import { IShopCurator } from "./shopCurator";

export type IShopRecord = {
  id?: number;
  documentId: string;
  name: string;
  image: StrapiImage | null;
  label: string;
  artist: string;
  year: string;
  description: string | null;
  shopCurator: IShopCurator | null;
  sold: boolean;
  quantity: number;
  imageUrl?: string;
  /**
   * The vinyl's id in Odoo, kept as a plain attribute [ROVR-4188]. Rows
   * written before it existed have none: up to 2025-11-29 Strapi took the Odoo
   * id as the row's primary key, so `id` holds it; after that `id` is just
   * Strapi's own PK. `odooId ?? id` is fine for a catalogue lookup (the two id
   * ranges don't overlap), but never send it back as an Odoo id.
   */
  odooId?: number | null;
  /**
   * `true` for one of the two optional picks shown beside the top 5 on the
   * Vinyl List [ROVR-4187]. `null` on rows written before the field existed,
   * which read as top-5 entries — only `=== true` marks an extra.
   */
  extra?: boolean | null;
};

export const emptyInitialStateShopRecord: IShopRecord = {
  id: undefined,
  documentId: "",
  name: "",
  image: null,
  label: "",
  artist: "",
  year: "",
  description: null,
  shopCurator: null,
  sold: false,
  quantity: 0,
  extra: false,
};
